import type { IAppCommandPromptProvider, IAppCommandPromptResultGroup, IAppCommandPromptResultItem } from "@@components/appcommandprompt/appcommandprompt";
import type { IMegaMenuBase, IMegaMenuConfig } from "./definitions";
import type { Entities } from '@inwink/entities/entities';
import type { ILocationMatchProp } from "@@data/entities";
import { removeDiacritics } from '@inwink/utils/methods/removediacritics';
import { menuSearchCommand } from "@@components/appcommandprompt/appcommandpromptcontext";


export interface IMegaMenuAppCommandContext {
    i18nHelper: Entities.i18nHelper;
    match: ILocationMatchProp;
}

export class MegaMenuAppCommand implements IAppCommandPromptProvider {
    //trigger = menuSearchCommand;
    
    name = "megamenusearch";

    getLabel(context: IMegaMenuAppCommandContext, e: IMegaMenuBase) {
        let entryName: string = null;
        if (e.title) {
            entryName = context.i18nHelper.translate(e.title, null, e.title);
        } else if (e.label) {
            entryName = context.i18nHelper.translateBag(e.label);
        }

        return entryName;
    }    

    search(search: string): Promise<IAppCommandPromptResultGroup[]> {
        const result: IAppCommandPromptResultGroup[] = [];
        const context = this.context();

        const tokens = search.split(' ').map((t) => {
            return removeDiacritics(t.toLowerCase());
        });

        this.menu.entries.forEach((e) => {
            let entryName = this.getLabel(context, e);
            const items: IAppCommandPromptResultItem[] = [];

            e.sections.forEach((s) => {
                let sectionName = this.getLabel(context, s);
                
                s.blocs.forEach((b) => {
                    let blocName = this.getLabel(context, b);
                    //let lowerBlocName  = blocName?.toLowerCase();

                    b.items.forEach((it) => {
                        let itemName = this.getLabel(context, it);
                        let lowerItemName = itemName?.toLowerCase();
                        lowerItemName = lowerItemName && removeDiacritics(lowerItemName);
                        let lowerKeyWords = it.keywords?.map((k) => removeDiacritics(k.toLowerCase())) || [];

                        const matchName = tokens.some((t) => lowerItemName && lowerItemName.indexOf(t) >= 0);  
                        const matchKeyworkds = (lowerKeyWords.length && lowerKeyWords.some((k) => tokens.some((t) => k.indexOf(t) >= 0)));  
                        const hasMatch = matchName || matchKeyworkds;

                        if (hasMatch) {
                            const linkTarget = context.match && it.link && it.link
                                .replace('{customerid}', context.match.params.customerid)
                                .replace('{tenantid}', context.match.params.tenantid)
                                .replace('{eventid}', context.match.params.eventid)
                                .replace('{communityid}', context.match.params.communityid);

                            items.push({
                                id: it.key,
                                label: itemName,
                                sublabel: [entryName, sectionName, blocName].filter((s) => !!s).join(" > "),
                                link: linkTarget
                            });
                        }
                    })
                });
            });

            if (items.length) {
                
                result.push({
                    label: entryName,
                    items: items
                })
            }
        });

        return Promise.resolve(result);
    }

    constructor(public menu: IMegaMenuConfig, public context: () => IMegaMenuAppCommandContext) {

    }
}
